


































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({})
export default class ButtonWithTooltip extends Vue {
    @Prop({ type: Boolean, default: false }) disabled
    @Prop({ type: String, default: '' }) tooltip

    mounted() {
        this.mountPopover()
    }

    @Watch('disabled')
    onLoaded() {
        this.mountPopover()
    }

    mountPopover() {
        requestAnimationFrame(() => {
            ;(<any>$('.popover-dismiss')).popover({
                trigger: 'hover',
                container: 'body',
                boundary: 'window',
            })
        })
    }

    onClick() {
        this.$emit('click')
    }
}
